import _slicedToArray from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/ubuntu/code/addictive-builder/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { getCurrentHub } from '@sentry/browser';
import { timestampWithMs } from '@sentry/utils';
import hoistNonReactStatics from 'hoist-non-react-statics';
import * as React from 'react';
import { REACT_MOUNT_OP, REACT_UPDATE_OP, REACT_RENDER_OP } from './constants.js';
var _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/profiler.tsx";
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

var UNKNOWN_COMPONENT = 'unknown';
/**
 * The Profiler component leverages Sentry's Tracing integration to generate
 * spans based on component lifecycles.
 */

var Profiler = /*#__PURE__*/function (_React$Component) {
  _inherits(Profiler, _React$Component);

  var _super = _createSuper(Profiler);

  function Profiler(props) {
    var _this;

    _classCallCheck(this, Profiler);

    _this = _super.call(this, props);

    Profiler.prototype.__init.call(_assertThisInitialized(_this));

    Profiler.prototype.__init2.call(_assertThisInitialized(_this));

    ;
    var _this$props = _this.props,
        name = _this$props.name,
        _this$props$disabled = _this$props.disabled,
        disabled = _this$props$disabled === void 0 ? false : _this$props$disabled;

    if (disabled) {
      return _possibleConstructorReturn(_this);
    }

    var activeTransaction = getActiveTransaction();

    if (activeTransaction) {
      _this._mountSpan = activeTransaction.startChild({
        description: "<".concat(name, ">"),
        op: REACT_MOUNT_OP
      });
    }

    return _this;
  } // If a component mounted, we can finish the mount activity.


  _createClass(Profiler, [{
    key: "__init",
    value:
    /**
     * The span of the mount activity
     * Made protected for the React Native SDK to access
     */
    function __init() {
      this._mountSpan = undefined;
    }
    /**
     * The span that represents the duration of time between shouldComponentUpdate and componentDidUpdate
     */

  }, {
    key: "__init2",
    value: function __init2() {
      this._updateSpan = undefined;
    } // eslint-disable-next-line @typescript-eslint/member-ordering

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._mountSpan) {
        this._mountSpan.finish();
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref) {
      var _this2 = this;

      var updateProps = _ref.updateProps,
          _ref$includeUpdates = _ref.includeUpdates,
          includeUpdates = _ref$includeUpdates === void 0 ? true : _ref$includeUpdates;

      // Only generate an update span if includeUpdates is true, if there is a valid mountSpan,
      // and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
      // We are just trying to give baseline clues for further investigation.
      if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
        // See what props haved changed between the previous props, and the current props. This is
        // set as data on the span. We just store the prop keys as the values could be potenially very large.
        var changedProps = Object.keys(updateProps).filter(function (k) {
          return updateProps[k] !== _this2.props.updateProps[k];
        });

        if (changedProps.length > 0) {
          var now = timestampWithMs();
          this._updateSpan = this._mountSpan.startChild({
            data: {
              changedProps: changedProps
            },
            description: "<".concat(this.props.name, ">"),
            op: REACT_UPDATE_OP,
            startTimestamp: now
          });
        }
      }

      return true;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this._updateSpan) {
        this._updateSpan.finish();

        this._updateSpan = undefined;
      }
    } // If a component is unmounted, we can say it is no longer on the screen.
    // This means we can finish the span representing the component render.

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
          name = _this$props2.name,
          _this$props2$includeR = _this$props2.includeRender,
          includeRender = _this$props2$includeR === void 0 ? true : _this$props2$includeR;

      if (this._mountSpan && includeRender) {
        // If we were able to obtain the spanId of the mount activity, we should set the
        // next activity as a child to the component mount activity.
        this._mountSpan.startChild({
          description: "<".concat(name, ">"),
          endTimestamp: timestampWithMs(),
          op: REACT_RENDER_OP,
          startTimestamp: this._mountSpan.endTimestamp
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line react/prop-types
      return this.props.children;
    }
  }], [{
    key: "__initStatic",
    value: function __initStatic() {
      this.defaultProps = {
        disabled: false,
        includeRender: true,
        includeUpdates: true
      };
    }
  }]);

  return Profiler;
}(React.Component);

Profiler.__initStatic();
/**
 * withProfiler is a higher order component that wraps a
 * component in a {@link Profiler} component. It is recommended that
 * the higher order component be used over the regular {@link Profiler} component.
 *
 * @param WrappedComponent component that is wrapped by Profiler
 * @param options the {@link ProfilerProps} you can pass into the Profiler
 */


function withProfiler(WrappedComponent, // We do not want to have `updateProps` given in options, it is instead filled through the HOC.
options) {
  var _this3 = this;

  var componentDisplayName = options && options.name || WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;

  var Wrapped = function Wrapped(props) {
    return React.createElement(Profiler, _objectSpread(_objectSpread({}, options), {}, {
      name: componentDisplayName,
      updateProps: props,
      __self: _this3,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 144
      }
    }), React.createElement(WrappedComponent, _objectSpread(_objectSpread({}, props), {}, {
      __self: _this3,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 145
      }
    })));
  };

  Wrapped.displayName = "profiler(".concat(componentDisplayName, ")"); // Copy over static methods from Wrapped component to Profiler HOC
  // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over

  hoistNonReactStatics(Wrapped, WrappedComponent);
  return Wrapped;
}
/**
 *
 * `useProfiler` is a React hook that profiles a React component.
 *
 * Requires React 16.8 or above.
 * @param name displayName of component being profiled
 */


function useProfiler(name) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    disabled: false,
    hasRenderSpan: true
  };

  var _React$useState = React.useState(function () {
    if (options && options.disabled) {
      return undefined;
    }

    var activeTransaction = getActiveTransaction();

    if (activeTransaction) {
      return activeTransaction.startChild({
        description: "<".concat(name, ">"),
        op: REACT_MOUNT_OP
      });
    }

    return undefined;
  }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      mountSpan = _React$useState2[0];

  React.useEffect(function () {
    if (mountSpan) {
      mountSpan.finish();
    }

    return function () {
      if (mountSpan && options.hasRenderSpan) {
        mountSpan.startChild({
          description: "<".concat(name, ">"),
          endTimestamp: timestampWithMs(),
          op: REACT_RENDER_OP,
          startTimestamp: mountSpan.endTimestamp
        });
      }
    }; // We only want this to run once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
/** Grabs active transaction off scope */


function getActiveTransaction() {
  var hub = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getCurrentHub();

  if (hub) {
    var scope = hub.getScope();

    if (scope) {
      return scope.getTransaction();
    }
  }

  return undefined;
}

export { Profiler, UNKNOWN_COMPONENT, getActiveTransaction, useProfiler, withProfiler };